import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminPaymentRequestsComponent } from './admin-payment-requests/admin-payment-requests.component';
import { StateWiseAmountBalanceComponent } from './state-wise-amount-balance/state-wise-amount-balance.component';
import { StateWiseDistributionComponent } from './state-wise-distribution/state-wise-distribution.component';
import { StateWiseExpenditureComponent } from './state-wise-expenditure/state-wise-expenditure.component';
import { StateWiseExpenditureViewComponent } from './state-wise-expenditure-view/state-wise-expenditure-view.component';
import { AddStateWalletBalanceComponent } from './add-state-wallet-balance/add-state-wallet-balance.component';
import { AddBranchWalletBalanceComponent } from './add-branch-wallet-balance/add-branch-wallet-balance.component';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'amount-balance'
  },
  {
    path: 'payment-requests',
    component: AdminPaymentRequestsComponent
  },
  {
    path: 'amount-balance',
    component: StateWiseAmountBalanceComponent
  },
  {
    path: 'distribution',
    component: StateWiseDistributionComponent
  },
  {
    path: 'expenditure/:id',
    component: StateWiseExpenditureComponent
  },
  {
    path: 'expenditure-view',
    component: StateWiseExpenditureViewComponent
  },
  {
    path: 'add-state-wallet',
    component: AddStateWalletBalanceComponent
  },
  {
    path: 'add-branch-wallet/:id',
    component: AddBranchWalletBalanceComponent
  },
  {
    path: 'transaction-details',
    component: TransactionDetailsComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WalletRoutingModule { }
